import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { ErrorMessagePipe } from '@app/shared/error-message.pipe';

@Component({
  selector: 'app-checkbox',
  imports: [ReactiveFormsModule, NgClass, ErrorMessagePipe],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.css',
  standalone: true,
})
export class CheckboxComponent {
  @Input() control!: FormControl;
  @Input() label!: string;
  @Input() inline: boolean = false;

  protected readonly Object = Object;

  toggleValue() {
    this.control.setValue(!this.control.value);
    this.control.markAsDirty();
  }
}
